import { useState, useEffect, FC } from 'react';
import { CommonModalProps } from './Types';
import { Modal, InputSelect } from '@wajeez-web/components/ui';
// import { useAppSelector } from '../../redux/hooks';

const SeeAllPageModal: FC<CommonModalProps<string>> = ({
  isOpen,
  onClose,
  data,
  onSubmit,
}) => {
  // const { collectionComponents } = useAppSelector(
  //   (state) => state.collectionComponents
  // );
  const [seeAllPageId, setSeeAllPageId] = useState('');

  useEffect(() => {
    data && setSeeAllPageId(data);
  }, [data]);
  return (
    <Modal
      title={'See All Page '}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => {
        onSubmit && onSubmit(seeAllPageId);
      }}
    >
      <InputSelect
        name={'seeAllPageId'}
        label={'see All Page Id'}
        options={
          []
          //   collectionComponents?.map((item) => ({
          //   label: item.referenceName,
          //   value: item.id,
          // }))
        }
        onChange={(name, value: any) => {
          setSeeAllPageId(value?.value);
        }}
        // value={
        //   seeAllPageId
        //     ? collectionComponents
        //         ?.map((item) => ({
        //           label: item.referenceName,
        //           value: item.id,
        //         }))
        //         .find(
        //           (item: { value: string; label: string }) =>
        //             item.value === seeAllPageId
        //         )
        //     : undefined
        // }
      />
    </Modal>
  );
};

export default SeeAllPageModal;
